"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { DrawerV2, Text } from "@nxt-costco-com/forge-components";
import { FontWeightBold, FontSize400, ColorTextSuccess } from "@nxt-costco-com/forge-design-tokens";
import { addToListActions } from "../constants.js";
import { ComponentRenderer } from "./components/ComponentRenderer.js";
import { SaveToListButton } from "./components/SaveToListButton.js";
import { DEFAULT_HEADER_PROPS } from "./constants.js";
const SaveToListDrawer = ({
  children,
  addToListModalOpen,
  dispatch,
  enableModernApis,
  locale,
  state,
  msStore,
  product,
  title = "Save to List",
  uniqueId
}) => {
  var _a, _b;
  const { drawerContent, isLoading, globalErrorMsg, globalSuccessMsg } = state;
  const [showSticky, setShowSticky] = useState(false);
  const level = (drawerContent == null ? void 0 : drawerContent.length) - 1;
  const { bodyContent = "saveToListUI" } = drawerContent[level] || {};
  const siteValue = msStore.getPropertiesItemsKeysItem(
    "clientid"
  );
  const saveToListTitle = msStore.getKeyValueItem("savetolisttitle");
  const DEFAULT_DRAWER = {
    bodyContent: "saveToListUI",
    hasStickyBar: false,
    title: saveToListTitle
  };
  useEffect(() => {
    dispatch({
      payload: {
        drawerContent: [DEFAULT_DRAWER]
      },
      type: addToListActions.UPDATE_STATE
    });
  }, []);
  useEffect(() => {
    if (globalErrorMsg || globalSuccessMsg) {
      setTimeout(
        () => {
          var _a2;
          return (_a2 = document.getElementById("save-to-list-global-notification")) == null ? void 0 : _a2.focus();
        },
        0
      );
    }
  }, [globalErrorMsg, globalSuccessMsg]);
  const resetDrawer = () => {
    dispatch({
      payload: {
        addToListModalOpen: false,
        isLoading: false,
        drawerContent: [DEFAULT_DRAWER],
        errorMsg: "",
        globalErrorMsg: "",
        globalSuccessMsg: "",
        successMsg: "",
        quantity: "1",
        wishListFetched: false
      },
      type: addToListActions.UPDATE_STATE
    });
  };
  if (!bodyContent) return null;
  const drawerTitle = ((_a = drawerContent[level]) == null ? void 0 : _a.title) || title;
  const successHeaderTitle = ((_b = drawerContent[level]) == null ? void 0 : _b.successHeaderTitle) || false;
  let finalDrawerTitle;
  if (successHeaderTitle) {
    finalDrawerTitle = /* @__PURE__ */ jsx(
      Text,
      {
        id: "dialog-title",
        sx: {
          color: ColorTextSuccess,
          fontSize: FontSize400,
          fontWeight: FontWeightBold
        },
        component: "h2",
        variant: "t4",
        children: drawerTitle
      }
    );
  } else {
    finalDrawerTitle = /* @__PURE__ */ jsx(
      Text,
      {
        id: "dialog-title",
        component: "h2",
        sx: { fontSize: FontSize400, fontWeight: FontWeightBold },
        variant: "t4",
        children: drawerTitle
      }
    );
  }
  const handleButtonRefocus = () => {
    if (!uniqueId) return;
    const btnElem = document.getElementById(uniqueId);
    btnElem == null ? void 0 : btnElem.focus();
  };
  return /* @__PURE__ */ jsxs(Box, { children: [
    children,
    /* @__PURE__ */ jsx(
      DrawerV2,
      {
        headerProps: {
          ...DEFAULT_HEADER_PROPS,
          level,
          onBack: () => {
            const updatedDrawerContent = [...drawerContent];
            dispatch({
              payload: {
                drawerContent: updatedDrawerContent.slice(
                  0,
                  -1
                ),
                errorMsg: "",
                globalErrorMsg: "",
                globalSuccessMsg: "",
                successMsg: ""
              },
              type: addToListActions.UPDATE_STATE
            });
          },
          onClose: () => resetDrawer(),
          title: finalDrawerTitle
        },
        onClose: () => {
          resetDrawer();
          handleButtonRefocus();
        },
        stickyBarContent: showSticky && bodyContent === "saveToListUI" && !isLoading ? /* @__PURE__ */ jsx(
          SaveToListButton,
          {
            dispatch,
            enableModernApis,
            locale,
            msStore,
            product,
            siteValue,
            state
          }
        ) : null,
        anchor: "right",
        open: addToListModalOpen,
        children: /* @__PURE__ */ jsx(
          ComponentRenderer,
          {
            bodyContent,
            dispatch,
            enableModernApis,
            locale,
            msStore,
            product,
            setShowSticky,
            showSticky,
            siteValue,
            state
          }
        )
      }
    )
  ] });
};
export {
  SaveToListDrawer
};
